module.exports = __webpack_public_path__ + "img/sorry.599bcab9.png";